import { forwardRef } from 'react'
import {
  ThemeUIStyleObject,
  Textarea as ThemeUITextarea,
  TextareaProps as ThemeUITextareaProps,
} from 'theme-ui'

export type TextareaProps = ThemeUITextareaProps & {}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ ...rest }, ref) => {
    const styleSx: ThemeUIStyleObject = rest.sx ?? {}
    return <ThemeUITextarea ref={ref as any} sx={styleSx} {...rest} />
  }
)
